import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=54dc0243&scoped=true"
import script from "./MaterialList.vue?vue&type=script&lang=js"
export * from "./MaterialList.vue?vue&type=script&lang=js"
import style0 from "./MaterialList.vue?vue&type=style&index=0&id=54dc0243&scoped=true&lang=css"
import style1 from "./MaterialList.vue?vue&type=style&index=1&id=54dc0243&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc0243",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dc0243')) {
      api.createRecord('54dc0243', component.options)
    } else {
      api.reload('54dc0243', component.options)
    }
    module.hot.accept("./MaterialList.vue?vue&type=template&id=54dc0243&scoped=true", function () {
      api.rerender('54dc0243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/MaterialList.vue"
export default component.exports